var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10257 15.8735L9.07957 15.6025L14.6796 9.99749L11.9836 7.30049L6.36657 12.9175L6.10257 15.8735ZM13.3236 5.96149L16.0186 8.65649L17.9656 6.70649L15.2716 4.01249L13.3236 5.96149ZM4.29257 17.6855C4.08257 17.4755 3.97757 17.1835 4.00357 16.8875L4.38257 12.7175C4.42457 12.2605 4.62657 11.8295 4.95257 11.5035L13.9486 2.50749C14.6506 1.80249 15.9236 1.83749 16.6646 2.57649L19.4026 5.31449L19.4036 5.31549C20.1686 6.08149 20.1996 7.29949 19.4716 8.02949L10.4746 17.0265C10.1496 17.3515 9.71857 17.5535 9.26057 17.5955L5.09057 17.9745C5.06057 17.9765 5.03057 17.9775 4.99957 17.9775C4.73657 17.9775 4.48157 17.8735 4.29257 17.6855ZM19.9996 20.9775C19.9996 21.5275 19.5496 21.9775 18.9996 21.9775H4.99957C4.45057 21.9775 3.99957 21.5275 3.99957 20.9775C3.99957 20.4285 4.45057 19.9775 4.99957 19.9775H18.9996C19.5496 19.9775 19.9996 20.4285 19.9996 20.9775Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit2.c9e84d687c9264e3299229ae3bff0d72.svg";
export { ForwardRef as ReactComponent };